/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.EditButtonNameAction.REQUEST_EDITBUTTONNAME:
      return {
        ...state,
    };
    case actions.EditButtonNameAction.EDITBUTTONNAME_RECEIVED:
          return{
      ...state,
    };

    default:
      return state;
  }
};

export default reducer;
